import UpdateBrokerForm from 'components/features/update-broker-form';
import HomeLayout from 'layouts/home-layout';

function UpdateBroker() {
  return (
    <HomeLayout title="Update Broker">
      <UpdateBrokerForm />
    </HomeLayout>
  );
}

export default UpdateBroker;
